import { httpClient } from 'utils/httpClient';
import { InstitucionData } from 'types/institucion.types';
import { setInstitucionData } from 'utils/appConfig';

const API = process.env.REACT_APP_API_URL ?? '';

// GET es público (se llama antes del login) — usa fetch directo sin token
async function fetchPublicInstitucion(): Promise<InstitucionData> {
  const res = await fetch(`${API}/institucion`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = await res.json();
  if (!body.success) throw new Error(body.message ?? 'Error al cargar institución');
  return body.data as InstitucionData;
}

export const institucionService = {
  async get(): Promise<InstitucionData> {
    const data = await fetchPublicInstitucion();
    setInstitucionData(data);
    return data;
  },

  async update(data: Partial<InstitucionData>): Promise<InstitucionData> {
    const updated = await httpClient.put<InstitucionData>('/institucion', data);
    setInstitucionData(updated);
    return updated;
  },
};
